import { ILogsModel } from "../models/LogsModel";
import { getFromLocal, setToLocal } from "./GenericHelpers";

export const getAllLogs = () => {
  const logsRaw = getFromLocal('logs')
  if (logsRaw) {
    return JSON.parse(logsRaw)
  } else return []
}

export const pushAllLogs = (data: ILogsModel[]) => {
  // const logs = getAllLogs();
  // data && setToLocal('logs', JSON.stringify([ ...logs, ...data ]))
  setToLocal('logs', JSON.stringify(data || []))
}

export const pushToLog = (data: ILogsModel) => {
  const logs = getAllLogs();
  setToLocal('logs', JSON.stringify([ ...logs, data ]))
}